module.exports = __webpack_public_path__ + "static/media/team-4.28cdf187.png";